import { Alert, Button } from "@nabble/ui";
import { useState } from "react";
import type { AccountInfo } from "../../../../api/account";
import { CancelEmailChangeDialog } from "./CancelEmailChangeDialog";
import { ChangeEmailDialog } from "./ChangeEmailDialog";

/** Emails → Primary email: the sign-in address, with any change still waiting for confirmation. */
export function PrimaryEmailRow({ account, onChanged }: { account: AccountInfo; onChanged: () => void }): React.JSX.Element {
  const [changeOpen, setChangeOpen] = useState<{ prefill: string } | null>(null);
  const [cancelOpen, setCancelOpen] = useState(false);

  return (
    <>
      <div className="nb-setting-row">
        <div>
          <div className="nb-setting-title">Primary email</div>
          <p className="nb-setting-desc">You sign in with it, and we send security notices to it.</p>
        </div>
        <div className="nb-setting-content">
          <div className="nb-row-between">
            <strong>{account.email}</strong>
            <Button label="Change" variant="secondary" size="sm" icon="edit" onClick={() => setChangeOpen({ prefill: "" })} />
          </div>
          {account.pendingEmail ? (
            <Alert tone="info">
              <div className="nb-stack">
                <span>{`Change to ${account.pendingEmail} waiting for confirmation.`}</span>
                <div className="nb-row">
                  <Button
                    label="Resend"
                    variant="secondary"
                    size="sm"
                    icon="send"
                    onClick={() => setChangeOpen({ prefill: account.pendingEmail ?? "" })}
                  />
                  <Button label="Cancel" variant="ghost" size="sm" icon="x" onClick={() => setCancelOpen(true)} />
                </div>
              </div>
            </Alert>
          ) : null}
        </div>
      </div>

      {changeOpen ? (
        <ChangeEmailDialog
          current={account.email}
          prefill={changeOpen.prefill}
          onClose={() => setChangeOpen(null)}
          onSent={() => {
            setChangeOpen(null);
            onChanged();
          }}
        />
      ) : null}

      <CancelEmailChangeDialog
        open={cancelOpen}
        account={account}
        onClose={() => setCancelOpen(false)}
        onCanceled={() => {
          setCancelOpen(false);
          onChanged();
        }}
      />
    </>
  );
}
